import { VALID_LETTERS } from '@src/constants/tts';
import { checkBrowser } from '@src/utils/browser';

const containsBlacklistedWords = ({ text, blackWord }) => {
  const currentBrowser = checkBrowser();
  const lowerText = text.toLowerCase();

  // Match blacklisted words with word boundaries, case-insensitive and Unicode support
  const regex = !currentBrowser?.safariAgent
    ? new RegExp(
        `(?<![${VALID_LETTERS}])${blackWord}(?![${VALID_LETTERS}])`,
        'g',
      )
    : new RegExp(
        `(^|[^${VALID_LETTERS}])${blackWord}(?![${VALID_LETTERS}])`,
        'g',
      );

  return regex.test(lowerText);
};

export { containsBlacklistedWords };
